module.exports = __webpack_public_path__ + "static/media/search.ae6bb9d8.svg";